<template src="./login.html"></template>

<script>

import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "Login",
  data() {
    return {
      login: '',
      password: '',
      remember_me: false,
      showAlertWrongUserPassword: false,
    }
  },
  mounted() {

    if(localStorage.getItem('Token') !== null) {
      
      //this.check_token_login()
    }
    this.login = localStorage.getItem("login")
    this.password = localStorage.getItem("password")
  },
  methods: {
    async check_token_login() {

      try {
        
        const url = API_URL+"login/LoginByToken/"
        const data = {
          token: localStorage.getItem("Token")
        }
        const response = await axios.post(url, data)

        if(response.data.message == "Correct") {

          localStorage.setItem("Token", response.data.token)
          localStorage.setItem("User_id", response.data.user_id)
          localStorage.setItem("Id", response.data.user_id)
          localStorage.setItem("Name", response.data.name)
          localStorage.setItem("UserAclRoleId", response.data.user_acl_role)
          router.push({path: "/application"})
        }
      }
      catch (error) {
 
         console.debug('Error during registration:', error)
      }
    },
    async execute_login() {
      
      const url = API_URL + "login/Login/";
      const data = {
        username: this.login,
        password: this.password,
      };

      try {

        const response = await axios.post(url, data, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json", 
          },
        })

        if(response.data.message === "Correct") {
          
          localStorage.setItem("Token", response.data.token)
          localStorage.setItem("User_id", response.data.user_id) // Users.id
          localStorage.setItem("Id", response.data.id)           // User.id
          localStorage.setItem("Name", response.data.name)
          localStorage.setItem("UserAclRoleId", response.data.user_acl_role)

          if(this.remember_me) {

            localStorage.setItem("login", this.login)
          } 
          else {
          
            localStorage.removeItem("login")
            localStorage.removeItem("password")
          }

          router.push({ path: "/application" })
        } 
        else if(response.data.message.startsWith("Utente o password sbagliata")) {

          this.showAlertWrongUserPassword = true
        }
      } 
      catch (error) {
      
        console.debug("Login failed:", error)

        if(error.response) {

          if(error.response.data && error.response.data.message) {

            this.showAlertWrongUserPassword = true
          } 
          else {
          
            alert("An unexpected error occurred. Please try again later.")
          }
        }
        else if(error.request) {

          alert("An unexpected error occurred. Please check your internet connection and try again.")
        } 
        else {
          
          alert("An unexpected error occurred. Please try again later.")
        }
      }
    },
    logout() {   /** TODO: Must be moved into NavBar in application **/

      const keysToRemove = ['Token', 'User_id', 'Name']
      keysToRemove.forEach((key) => {
      
        localStorage.removeItem(key)
      })
    },
    recover_password() {

      router.push({path: "/recover"})
    },
    goto_register() {

      router.push({path: "/register"})
    },
  },
}

</script>